export const LIST_ITEM_DATA_FIELD = {
  label: 'label',
  icon: 'icon',
};
